


































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import {onValidation, removeOnValidation, sendData} from '@/modules/sigcom'
import {Prop} from 'vue-property-decorator'
import {State} from "vuex-class";
import {ConfigMap} from "@/modules/config";
import {AppConfigParameters} from "@/store";

export interface Validation {
    valid: boolean;
    reason: string;
}

/**
 * Validación de identidad
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class IdentityValidation extends Vue {
    /**
     * Emitirá el evento next de forma automática si la validación es correcta
     */
    @Prop({type: Boolean, default: false})
    autoNext: boolean

    /**
     * Configuración de la aplicación
     */
    @State(state => state.appConfig)
    public config: ConfigMap

    public validating = false
    public lastDNI = ''

    public validation: Validation | null = null
    public dniRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i

    /**
     * Mascara para el campo donde se introduce el documento de identidad.
     *
     * Si la validación de DNI se encuentra activa generará una mascara de 8 dígitos
     * y una letra. De lo contraria creará una mascará de 30 caracteres
     * alfanuméricos.
     */
    public get identityMask () {
        return this.dniValidation ? '########A' : 'X'.repeat(30)
    }

    public get avatarConfig() {
        if (!this.validation) {
            return {
                icon: 'mdi-text-box-search-outline',
                color: 'blue',
            }
        }

        return {
            icon: this.validation.valid ? 'mdi-text-box-check-outline' : 'mdi-text-box-remove-outline',
            color: this.validation.valid ? 'green' : 'red'
        }
    }

    /**
     * Comprueba si se encuentra activa la validación de DNI
     */
    public get dniValidation () {
        return this.config[AppConfigParameters.ValidateDNIFormat] || false
    }

    /**
     * Comprueba que el DNI introducido por el usuario es correcto
     */
    public validateDNI (dni: string) {
        // No es necesario realizar la validación del formato
        if (!this.dniValidation) {
            return true
        }

        if (!dni || this.lastDNI === dni || !this.dniRegex.test(dni)) {
            return false
        }

        this.lastDNI = dni

        return true
    }

    /**
     * Valida el DNI introducido por el usuario
     */
    public onInput = _.debounce(async function (this: IdentityValidation, value: string) {
        if (!this.validateDNI(value)) {
            return
        }

        this.validating = true

        await sendData({
          nif: value,
        })
    }, 500)

    created () {
        onValidation((validation) => {
            this.validation = validation
            this.validating = false

            if (this.validation.valid && this.autoNext) {
                this.$emit('next')
            }
        })
    }

    destroyed () {
        removeOnValidation()
    }
}
